import { FormProfile } from 'components/user/user-detail/tab-profile/FormProfile'
import { useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { useDispatch, useSelector } from 'react-redux'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { EDIT_PROFILE_VALIDATION } from 'services/validation/userValidation'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { setIsReload } from 'reducers/userReducer'
import { Alert } from 'avo-ui'

const FIELD_NAME_DETAIL = {
    profile_picture: 'Foto profile',
    name: 'Nama',
    email: 'Email',
    birth_date: 'Tanggal lahir',
    phone_number: 'Nomor handphone',
    gender: 'Jenis kelamin',
}

export const FormProfileContainer = ({ show, onHide }) => {
    const dispatch = useDispatch()
    const { userDetails } = useSelector((state) => state.userReducer)
    const [dataProfile, setDataProfile] = useState({
        ...userDetails?.profile,
        phone_number: userDetails?.profile?.phone_number?.replace(/^62/, ''),
    })
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: dataProfile,
        schema: EDIT_PROFILE_VALIDATION,
    })
    const { fetching: updateUserDetailApi, isLoading } = useFetch(API_USER.UPDATE)
    const { fetching: getUrlImagesAPi } = useFetch(API_USER.URL_UPLOAD_IMAGES)

    const onHideForm = () => {
        onHide()
        clearErrorForm()
        setErrorMessage({})
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setDataProfile({ ...dataProfile, [name]: value })
    }

    const setUploadUserImage = async () => {
        try {
            const s3Urls = await getUrlImagesAPi({ filename: dataProfile?.profile_picture?.name?.replace(/\s/g, '') })
            await uploadFileToS3(s3Urls?.data, dataProfile?.profile_picture?.file)
            onSave(`${s3Urls.data.url}${s3Urls.data.fields.key}`)
        } catch (err) {
            console.log('upload failed')
        }
    }

    const onSave = (url) => {
        let payload = {
            ...dataProfile,
            profile_picture: !!url ? url : dataProfile?.profile_picture,
            phone_number: dataProfile?.phone_number ? `62${dataProfile?.phone_number}` : null,
        }
        updateUserDetailApi(payload, userDetails?.profile?.id)
            .then(() => {
                dispatch(setIsReload())
                onHideForm()
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Profile Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            if (dataProfile?.profile_picture?.file) {
                setUploadUserImage()
            } else {
                onSave()
            }
        })
    }

    const props = {
        show,
        onHideForm,
        dataProfile,
        isLoading,
        onChangeForm,
        errorForm: { ...errorForm, ...errorMessage },
        onSubmit,
    }

    return <FormProfile {...props} />
}
